import { notificationOptions } from '@/notifications/notifications.config';

export function getNotificationOptions (body) {
	return {
		body,
		icon: notificationOptions.icon,
		dir: notificationOptions.dir,
		lang: notificationOptions.lang,
		vibrate: [200, 100, 200],
	};
}
